/** Desktop left icon rail sits just below the unified navbar (lg: top-0, ~3.5rem tall). */
export const HOME_DESKTOP_RAIL_TOP_CLASS = "top-14";
export const HOME_DESKTOP_RAIL_PADDING_CLASS = "pt-2 pb-7";
export const HOME_DESKTOP_LEFT_RAIL_CLASS = "left-6";
export const HOME_DESKTOP_RIGHT_RAIL_CLASS = "right-8";
export const HOME_DESKTOP_CONTENT_TOP_CLASS = "lg:pt-0";
export const HOME_DESKTOP_ICON_RAIL_WIDTH_CLASS = "w-12";
export const HOME_DESKTOP_ICON_CENTER_ANCHOR_CLASS = "left-6";
